// LUMINA · pages/vajra/VajraSettings.jsx
// Phase 39D: 弟子专属设置 + 世间法工具开关

import React, { useState, useEffect } from 'react';
import { GD, GDH } from './constants';
import MyCredentials from './components/MyCredentials';
import CredentialApplication from './components/CredentialApplication';
import { API } from '../../constants/config';

export default function VajraSettings({ member, showEnergyTools, setShowEnergyTools, token, lang, T, setLang }) {
  const t = T || {};
  const isDisciple = member?.is_disciple;

  const toggle = () => {
    const next = !showEnergyTools;
    setShowEnergyTools(next);
    localStorage.setItem("vajra_show_energy_tools", next ? "1" : "0");
  };

  return (
    <div style={{maxWidth:560,margin:"32px auto",padding:"0 4px"}}>
      <div style={{color:GD,fontSize:11,letterSpacing:2,textTransform:"uppercase",marginBottom:20}}>
        {t.settingsTitle || "修行域设置"}
      </div>

      {/* Language switcher */}
      {setLang && (
        <div style={{background:"#ffffff",border:"1px solid rgba(212,175,55,0.15)",borderRadius:12,padding:20,marginBottom:16,boxShadow:"0 2px 8px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:14,color:"#333",letterSpacing:.3,marginBottom:10}}>{t.settingsLanguage || "语言 / Language"}</div>
          <div style={{display:"flex",gap:8}}>
            {["zh","en"].map(l=>(
              <button key={l} onClick={()=>setLang(l)} style={{
                padding:"6px 20px",borderRadius:20,fontSize:12,cursor:"pointer",
                background:lang===l?GDH:"transparent",
                border:`1px solid ${lang===l?GDH:"rgba(212,175,55,0.3)"}`,
                color:lang===l?"#fff":GD,
              }}>{l==="zh"?"中文":"English"}</button>
            ))}
          </div>
        </div>
      )}
      <div style={{
        background:"#ffffff",border:"1px solid rgba(212,175,55,0.15)",
        borderRadius:12,padding:20,marginBottom:16,boxShadow:"0 2px 8px rgba(0,0,0,0.06)",
      }}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:16}}>
          <div style={{flex:1}}>
            <div style={{fontSize:14,color:"#333",letterSpacing:.3}}>{t.settingsEnergyTools || "显示世间法辅助工具"}</div>
            <div style={{fontSize:12,color:"#888",lineHeight:1.7,marginTop:5}}>
              {t.settingsEnergyToolsDesc || "开启后，侧边栏将显示与您命盘关联的五行数据及本尊护持建议。"}
              {isDisciple && (
                <span style={{display:"block",marginTop:4,color:"rgba(184,134,11,0.7)"}}>
                  {lang === "en" ? "As a lineage disciple, this tool is hidden by default to maintain practice clarity." : "作为传承弟子，此工具默认隐藏以保持道场清净。"}
                </span>
              )}
            </div>
          </div>
          <button onClick={toggle} style={{
            width:48,height:26,borderRadius:13,border:"none",cursor:"pointer",
            background:showEnergyTools?"#064E3B":"rgba(0,0,0,0.12)",
            position:"relative",flexShrink:0,transition:"background .25s",outline:"none",
          }}>
            <div style={{
              position:"absolute",top:3,
              left:showEnergyTools?26:3,
              width:20,height:20,borderRadius:"50%",
              background:"#fff",boxShadow:"0 1px 4px rgba(0,0,0,0.2)",
              transition:"left .25s",
            }}/>
          </button>
        </div>
        <div style={{marginTop:10,fontSize:11,
          color:showEnergyTools?"#064E3B":"#bbb",letterSpacing:.5,transition:"color .2s"}}>
          {showEnergyTools
            ? (lang === "en" ? "✓ Enabled — energy data visible" : "✓ 已开启 — 能量数据可见")
            : (lang === "en" ? "Off — practice focus mode" : "已关闭 — 道场专注模式")}
        </div>
      </div>
      <div style={{
        background:"#ffffff",border:"1px solid rgba(212,175,55,0.15)",
        borderRadius:12,padding:20,boxShadow:"0 2px 8px rgba(0,0,0,0.06)",
      }}>
        <div style={{fontSize:11,color:"#aaa",letterSpacing:2,textTransform:"uppercase",marginBottom:12}}>{lang === "en" ? "Account" : "账户信息"}</div>
        <div style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:"8px 16px",fontSize:13}}>
          <span style={{color:"#999"}}>{lang === "en" ? "Dharma Name" : "法名"}</span>
          <span style={{color:"#444"}}>{member?.dharma_name || "—"}</span>
          <span style={{color:"#999"}}>{lang === "en" ? "Tier" : "层级"}</span>
          <span style={{color:GD,textTransform:"uppercase",letterSpacing:.5}}>{member?.vajra_tier || "free"}</span>
          <span style={{color:"#999"}}>{lang === "en" ? "Lineage Disciple" : "传承弟子"}</span>
          <span style={{color:member?.is_disciple?"#064E3B":"#bbb"}}>
            {member?.is_disciple ? (lang === "en" ? "✓ Yes" : "✓ 是") : (lang === "en" ? "No" : "否")}
          </span>
          <span style={{color:"#999"}}>{t.email || "邮箱"}</span>
          <span style={{color:"#666",fontSize:12}}>{member?.email || "—"}</span>
        </div>
      </div>
      {token && <MyCredentials token={token} />}
      {token && <CredentialApplication token={token} member={member} lang={lang} />}
      {token && <ReportActivation token={token} lang={lang} t={t} />}
    </div>
  );
}

function ReportActivation({ token, lang, t = {} }) {
  const [reportNum, setReportNum] = useState("");
  const [status, setStatus]       = useState(null);  // {ok, message}
  const [loading, setLoading]     = useState(false);
  const [access, setAccess]       = useState(null);

  useEffect(() => {
    fetch(`${API}/vajra/me/report-access`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setAccess(d); })
      .catch(() => {});
  }, [token]);

  const activate = async () => {
    if (!reportNum.trim()) return;
    setLoading(true); setStatus(null);
    try {
      const r = await fetch(`${API}/vajra/me/activate-report`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ report_number: reportNum.trim() }),
      });
      const d = await r.json();
      if (r.ok) {
        setStatus({ ok: true, message: d.message || "激活成功" });
        setAccess(null);  // will refresh
      } else {
        setStatus({ ok: false, message: d.detail || "激活失败" });
      }
    } catch { setStatus({ ok: false, message: "网络错误，请稍后再试" }); }
    setLoading(false);
  };

  return (
    <div style={{
      background: "#ffffff", border: "1px solid rgba(212,175,55,0.15)",
      borderRadius: 12, padding: 20, marginTop: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    }}>
      <div style={{ fontSize: 11, color: "#aaa", letterSpacing: 2, textTransform: "uppercase", marginBottom: 14 }}>{t.settingsReportActivation || "能量报告激活"}</div>

      {access?.has_report_access && (
        <div style={{ fontSize: 12, color: GD, marginBottom: 12, padding: "8px 12px", background: "rgba(6,78,59,0.06)", borderRadius: 7 }}>
          ✅ 已激活 · {access.unlocked_tiers.join("/")} 等级 · 法教 Level 1-{access.max_level}
        </div>
      )}

      <div style={{ fontSize: 12, color: "#666", lineHeight: 1.7, marginBottom: 12 }}>
        {t.settingsReportActivationDesc || "输入你的 LUMINA 报告编号，解锁对应层级的法教资料权限。"}<br/>
        <span style={{ color: "#aaa" }}>{lang === "en" ? "Your report number can be found on the report cover or in the generated email." : "报告编号在能量报告封面或生成邮件中可以找到。"}</span>
      </div>

      <div style={{ display: "flex", gap: 8 }}>
        <input value={reportNum} onChange={e => setReportNum(e.target.value)}
          placeholder={t.settingsReportPlaceholder || "如：CG-19780711-ABC"}
          style={{ flex: 1, padding: "8px 10px", border: "1px solid rgba(0,0,0,0.12)", borderRadius: 7, fontSize: 13 }} />
        <button onClick={activate} disabled={loading || !reportNum.trim()}
          style={{ padding: "8px 16px", background: loading ? "#9ca3af" : GD, color: "#fff", border: "none", borderRadius: 7, fontSize: 13, cursor: loading ? "not-allowed" : "pointer", whiteSpace: "nowrap" }}>
          {loading ? "…" : (t.settingsActivate || "激活")}
        </button>
      </div>

      {status && (
        <div style={{ marginTop: 10, fontSize: 12, color: status.ok ? GD : "#c0392b", padding: "6px 10px", background: status.ok ? "rgba(6,78,59,0.06)" : "rgba(192,57,43,0.06)", borderRadius: 6 }}>
          {status.ok ? "✅ " : "✗ "}{status.message}
        </div>
      )}
    </div>
  );
}
